/**
 * SCRUM-241 — Structura Picking: contenedor de rutas.
 *
 * Sin guard ni chrome propio: el guard de sesión vive en PickingShell, que cada
 * pantalla envuelve por su cuenta, porque /picking/pair debe quedar accesible
 * sin sesión.
 */
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/picking")({
  component: () => <Outlet />,
});
